import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next()
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        // console.log('路由拦截中调拉起用户信息接口了。。。')
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          // console.log('拉取用户信息接口返回的内容res=>', res)
          let menus=res.data.menus;
          let username=res.data.user.username;
          store.dispatch('GenerateRoutes', { menus,username }).then(() => { // 生成可访问的路由表
            //console.log(store.getters.addRouters,'21')
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表

            next({ ...to, replace: true })
          })
        }).catch((err) => {
          // console.log('拉取用户信息接口返回错误err=>', err)
          store.dispatch('FedLogOut').then(() => {
            // Message.error(err || 'Verification failed, please login again')
            // next('/login')
            if (whiteList.indexOf(to.path) !== -1) {
              next()
            } else {
              next('/login')
              NProgress.done()
            }
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js